import types from 'helpers/constants';

const initialState = {
  packages: [],
};

// eslint-disable-next-line func-style, default-param-last -- FIXME
function Packages(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PACKAGES:
      // eslint-disable-next-line no-console -- FIXME
      console.log(action.payload);
      return {
        ...state,
        packages: action.payload.packages,
        loading: false,
      };
    default:
      return state;
  }
}

export default Packages;
